import styled from '@emotion/styled'
import { FaqContentDto } from '@pharmac-extranet/management-api'
import { PharmacAccordion, PharmacAccordionContent, PharmacAccordionHandle } from '@pharmac/ui'
import { PropsWithChildren } from 'react'
import { useLanguage } from '../../hooks'
import { htmlStringSanitizer } from '../../utils'
import { ExtranetContainer } from '../ExtranetContainer'
import { ExtranetTextDiv } from '../ExtranetTextDiv'
import { DraggableAttributes, SyntheticListenerMap } from './FaqCategoryAccordion'

type FaqContentAccordionProps = PropsWithChildren & {
  data: FaqContentDto
  dndRef?: (node: HTMLElement | null) => void
  dndStyle?: {
    transform?: string
    transition?: string
  }
  attributes?: DraggableAttributes
  listeners?: SyntheticListenerMap
}

const AccordionContainer = styled.div`
  touch-action: manipulation;
  margin-bottom: 0.1rem;
`

export const FaqContentAccordion = ({
  children,
  data,
  dndRef,
  dndStyle,
  attributes,
  listeners,
}: FaqContentAccordionProps) => {
  const { key } = useLanguage()

  return (
    <AccordionContainer
      ref={dndRef}
      style={dndStyle}
      {...attributes}
      {...listeners}
    >
      <PharmacAccordion
        handle={({ isOpen }: any) => (
          <PharmacAccordionHandle
            color="secondary"
            isOpen={isOpen}
          >
            <ExtranetContainer
              style={{ width: '97%' }}
              spaceBetween
              alignCenter
            >
              {children}
            </ExtranetContainer>
          </PharmacAccordionHandle>
        )}
      >
        <PharmacAccordionContent color="secondary">
          <ExtranetTextDiv
            data={key(data.answer)}
            dangerouslySetInnerHTML={{
              __html: htmlStringSanitizer(key(data.answer)) ?? '',
            }}
          />
        </PharmacAccordionContent>
      </PharmacAccordion>
    </AccordionContainer>
  )
}
